<template>
  <div>
    <div>
      <u> {{ title }}: </u>
    </div>
    <div>
      {{ optionTitle }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'RecruiterIcoCriteriaResultTypeMultiVariableSelectOne',
  props: {
    jobQuestion: {
      type: Object,
      required: true,
    },
    variable: {
      type: Object,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    title: function () {
      return this.variable.short_label || this.variable.input_label;
    },
    optionTitle: function () {
      const option = this.variable.variableOptions.find(
        (o) => o.id === parseInt(this.value)
      );
      return option.name;
    },
  },
};
</script>

<style scoped />
